// import React, { useEffect, useMemo, useState } from "react";
// import './LedgerList.css'
// import { Edit, Trash } from "lucide-react";
// import axios from "axios";
// import toast from "react-hot-toast";
// import { getBranches } from "../redux/slices/branchSlice";
// import { useDispatch, useSelector } from "react-redux";

// const LedgerList = () => {
//   const dispatch = useDispatch();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [modalOpen, setModalOpen] = useState(false);
//   const [editIndex, setEditIndex] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [groups,setGroups]=useState([]);
//   const [selectedGroup,setSelectedGroup]=useState(null);
//   const [branch,setBranch]=useState([]);
//   const [selectedBranch,setSelectedBranch]=useState(null);

//   const superAdminId = localStorage.getItem("adminuserId");
//   const rowsPerPage = 5;
  


 

//   // Dynamic State Data
//   const [ledgers, setLedgers] = useState([]);


//   const fetchLedgers = async (page = currentPage) => {
//       // console.log(superAdminId);
//       try {
//         const res = await axios.get(
//           `https://payyug.in/api/ledger/getall`,{
//             params: {
//               superAdminId,
//               page,
//               limit: rowsPerPage,
//             }
//           }
//         );
  
//         // console.log("response ledgers data", res);
      
//         setLedgers(res.data.rows || []);
//         setTotalPages(res.data.totalPages || 1);
//         // setCurrentPage(res.data.currentPage || page);
//       } catch (err) {
//         console.error("Fetch Error:", err);
//       }
//    };

//   const fetchGroups = async () => { 
//     // console.log(superAdminId);
//     try {
//       const res = await axios.get(
//         `https://payyug.in/api/ledger-group/get-all?superAdminId=${superAdminId || 14}`
//       );

//       console.log("response data", res);
//       setGroups(res.data.data || []);
//     } catch (err) {
//       console.error("Fetch Error:", err);
//     }
//   };
  
//    const fetchBranchs = async () => { 
//     // console.log(superAdminId);
//     try {
//       const res = await axios.get(
//         `https://payyug.in/api/get-branch`,{
//         params: { 
//           SuperAdminId:superAdminId,
//           limit:"all"
//         },}
//       );

//       console.log("branch data", res);
//       setBranch(res.data.branches || []);
//     } catch (err) {
//       console.error("Fetch Error:", err);
//     }
//    };


//   const createUpdate = async (e) => {
//     e.preventDefault();
//     console.log("formdata values are",formData);
//     var payload = {
//       name: formData.name,
//       alias: formData.alias,
//       group_id: selectedGroup?.id,
//       openingBalance: Number(formData.openingBalance),
//       superAdminId: superAdminId,
//       branchId: selectedBranch?.id
//     }

//     try {
//       if (editIndex !== null) {
//         // ===================== UPDATE ======================
//       const res=  await axios.put(`https://payyug.in/api/ledger/update/${editIndex}`, payload);
//         toast.success(res?.data?.messag||"Center updated successfully");
//       } else {
//         // ===================== CREATE ======================
//        const res= await axios.post(`https://payyug.in/api/ledger/create`, payload);

//         toast.success(res?.data?.message||"Center created successfully");
//       }

//       fetchLedgers();
//       setModalOpen(false);
//     } catch (error) {
//       console.error("API Error:", error);

//       const message =
//         error?.response?.data?.error || // API-provided error
//         error?.message ||                // Network / Axios message
//         "Failed to save";

//       toast.error(message);
//     }

//   };

//   const handledelete = (id) => async () => {
//       const confirmDelete = window.confirm("Are you sure you want to delete this center?");
//       if (!confirmDelete) return;

//       try {
//         const res=await axios.delete(`https://payyug.in/api/ledger/delete/${id}`);
//         toast.success(res?.data?.message||"Center deleted successfully");
//         fetchLedgers();
//       } catch (error) {
//         toast.error("Failed to delete center");
//       }
//    };

//   useEffect(()=> {
//       fetchLedgers();
//    },[currentPage]);
  

//   useEffect(()=> {
//      fetchGroups();
//      fetchBranchs()
//   },[])

//   // Form Data
//   const [formData, setFormData] = useState({
//     name: "",
//     alias: "",
//     group: "",
//     branch: "",
//     openingBalance:""
//   });

//   // Input Change
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   // Create/Update Submit
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!formData.name || !formData.alias || !formData.group || !formData.branch || !formData.openingBalance ) {
//       alert("Please fill all fields");
//       return;
//     }

//     if (editIndex !== null) {
//       const updated = [...ledgers];
//       updated[editIndex] = { ...updated[editIndex], ...formData };
//       setLedgers(updated);
//       setEditIndex(null);
//     } else {
//       setLedgers([
//         ...ledgers,
//         { id: ledgers.length + 1, ...formData },
//       ]);
//     }

//     setFormData({ name: "", alias: "",group:"", branch: "",openingBalance:"" });
//     setModalOpen(false);
//   };

//   // Edit Handler
//   const handleEdit = (index) => {
//     setEditIndex(index.id);
//     setFormData({
//       name: index.name,
//       alias: index.alias,
//       group: index.group_id,
//       branch: index.branchId,
//       openingBalance:index.openingBalance
//     });
//     setModalOpen(true);
//   };

//   // Search + Pagination
//   const filteredData = useMemo(() => {
//     let data = [...ledgers];

//     if (searchQuery.trim()) {
//       data = data.filter((item) =>
//         Object.values(item)
//           .join(" ")
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase())
//       );
//     }

//     // if (searchQuery.trim()) {
//     //   data = data.filter((item) =>
//     // item.group.toLowerCase().includes(searchQuery.toLowerCase()) ||
//     // item.type.toLowerCase().includes(searchQuery.toLowerCase()) ||
//     // item.status.toLowerCase().includes(searchQuery.toLowerCase())
//     //   );
//     // }

//     return data;
//   }, [ledgers, searchQuery]);

//   // const totalPages = Math.ceil(filteredData.length / rowsPerPage);
//   const paginatedData = filteredData;
//   // .slice(
//   //   (currentPage - 1) * rowsPerPage,
//   //   currentPage * rowsPerPage
//   // );

//   return (
//     <>
//       <div className="account-ledger-list-container">
//         <h2 className="heading">Ledger List</h2>

//         <div className="account-ledger-list-top-section">
//           <input
//             type="text"
//             placeholder="Search by Group / Type / Status..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />

//           <button
//             className="add-btn"
//             onClick={() => {
//               setFormData({ name: "", alias: "",group:"", branch: "",openingBalance:"" });
//               setEditIndex(null);
//               setModalOpen(true);
//             }}
//           >
//             Add New
//           </button>
//         </div>

//         {/* Table */}
//         <div className="account-ledger-list-report-section">
//           <table className="account-ledger-list-report-table">
//             <thead>
//               <tr>
//                 <th>SN</th>
//                 <th>Ledger Name</th>
//                 <th>Alias</th>
//                 <th>Group ID</th>
//                 <th>Status</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>

//            <tbody>
//             {paginatedData.length > 0 ? (
//               paginatedData
//                 .map((item, index) => (
//                   <tr key={item.id}>
//                     <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//                     <td>{item.name}</td>
//                     <td>{item.alias}</td>
//                     <td>{item.group_id}</td>
//                     <td>{item.status}</td>
//                     <td>
//                       <button
//                         onClick={() =>
//                           // (currentPage - 1) * rowsPerPage + index
//                           handleEdit(item)
//                         }
//                       >
//                         <Edit size={18} />
//                       </button>
//                       <Trash
//                         className="delete-icon-gl"
//                         onClick={ handledelete(item.id)}
//                       />
//                     </td>
//                   </tr>
//                 ))
//              ) : (
//               <tr>
//                 <td colSpan="6" style={{ textAlign: "center" }}>
//                   No  records found
//                 </td>
//                 </tr>
//               )}
//            </tbody>


//           </table>
//         </div>

//          {/* Pagination */}
//          <div className="account-ledger-list-pagination-section">
//             <div className="account-ledger-list-pagination-div">
//               <button
//                 onClick={() => setCurrentPage(currentPage - 1)}
//                 disabled={currentPage === 1}
//               >
//                 ⬅ Prev
//               </button>

//               <span>
//                 Page {currentPage} of {totalPages}
//               </span>

//               <button
//                 onClick={() => setCurrentPage(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//               >
//                 Next ➡
//               </button>
//             </div>
//          </div>
         
//         {/* Modal */}
//         {modalOpen && (
//           <div className="dialog-overlay">
//             <div className="dialog-box">
//               <h2 className="dialog-box-heading">
//                 {editIndex !== null ? "Edit Ledger" : "Add New Ledger"}
//               </h2>

//               <form className="dialog-box-form-section" onSubmit={createUpdate}>
//                 <div className="dialog-box-input-group">
//                   <label>Ledger Name</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="dialog-box-input-group">
//                   <label>Alias</label>
//                   <input
//                     type="text"
//                     name="alias"
//                     value={formData.alias}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="dialog-box-input-group">
//                   <label>Opening Balance</label>
//                   <input
//                     type="text"
//                     name="openingBalance"
//                     value={formData.openingBalance}
//                     onChange={handleChange}
//                   />
//                 </div>



//                 <div className="dialog-box-input-group">
//                   <label>Group</label>
//                   <select name="group" 
//                           value={formData.group} 
//                           // onChange={handleChange}>
//                           onChange={(e) => {
//                           handleChange(e); 
//                           const group = groups.find(
//                             (c) => c.id === Number(e.target.value)
//                           );
//                           setSelectedGroup(group);
//                         }}>
//                       <option value="">Select Group</option>
//                       {groups.map((gn) => (
//                         <option key={gn.id} value={gn.id}>
//                           {gn.name}
//                         </option>
//                       ))}
//                   </select>
//                 </div>

//                 <div className="dialog-box-input-group">
//                   <label>Select Branch</label>
//                   <select name="branch" 
//                          value={formData.branch}
//                           // onChange={handleChange}>
//                        onChange={(e) => {
//                           handleChange(e); 
//                           const group = branch.find(
//                             (c) => c.id === Number(e.target.value)
//                           );
//                           setSelectedBranch(group);
//                       }}>
//                     <option value="">Select Branch</option>
//                     {branch.map((br) => (
//                         <option key={br.id} value={br.id}>
//                           {br.name}
//                         </option>
//                       ))}
//                   </select>
//                 </div>

//                 <div className="dialog-btns">
//                   <button type="submit">
//                     {editIndex !== null ? "Update" : "Create"}
//                   </button>

//                   <button type="button" onClick={() => setModalOpen(false)}>
//                     Cancel
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default LedgerList





import React, { useEffect, useState, useMemo, useCallback } from "react";
import "./LedgerList.css";
import { Edit, Trash, FileSpreadsheet, FileText } from "lucide-react";
import axios from "axios";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { toast } from "react-toastify";

const BASE_URL = "https://payyug.in/api";

const getBase64ImageFromUrl = async (imageUrl) => {
  if (!imageUrl) return null;
  try {
    const response = await fetch(imageUrl, { mode: "cors" });
    if (!response.ok) return null;
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = () => reject(null);
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Image loading failed:", error);
    return null;
  }
};

const LedgerList = () => {
  const [ledgers, setLedgers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [branches, setBranches] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = useState(null);

  // Pagination State
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Form & Modals State
  const [modalOpen, setModalOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  // Delete Confirmation Modal State
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const superAdminId = useMemo(
    () => localStorage.getItem("adminuserId") || 14,
    []
  );

  // Form State
  const [formData, setFormData] = useState({
    name: "",
    alias: "",
    group: "",
    openingBalance: "",
  });

  /* ================= FETCH COMPANY DETAILS ================= */
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/get-company?superAdminId=${superAdminId}`
        );
        const data = await response.json();

        if (response.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      }
    };

    if (superAdminId) fetchCompany();
  }, [superAdminId]);

  /* ================= FETCH LEDGERS ================= */
  const fetchLedgers = useCallback(
    async (page = currentPage) => {
      setLoading(true);
      try {
        const limitParam = rowsPerPage === "ALL" ? 100000 : rowsPerPage;
        const res = await axios.get(`${BASE_URL}/ledger/getall`, {
          params: {
            superAdminId,
            page,
            limit: limitParam,
          },
        });

        setLedgers(res.data.rows || res.data.data || []);
        setTotalPages(res.data.totalPages || 1);
      } catch (err) {
        console.error("Fetch Ledgers Error:", err);
        toast.error("Failed to fetch ledgers");
      } finally {
        setLoading(false);
      }
    },
    [superAdminId, currentPage, rowsPerPage]
  );

  useEffect(() => {
    fetchLedgers();
  }, [fetchLedgers]);

  /* ================= FETCH GROUPS ================= */
  const fetchGroups = useCallback(async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/ledger-group/get-all?superAdminId=${superAdminId}`
      );
      setGroups(res.data.data || []);
    } catch (err) {
      console.error("Fetch Groups Error:", err);
    }
  }, [superAdminId]);

  /* ================= FETCH BRANCHES ================= */
  const fetchBranches = useCallback(async () => {
    try {
      const res = await axios.get(`${BASE_URL}/get-branch`, {
        params: { SuperAdminId: superAdminId, limit: "all" },
      });
      setBranches(res?.data?.branches || []);
    } catch (err) {
      console.error("Fetch Branch Error:", err);
    }
  }, [superAdminId]);

  useEffect(() => {
    fetchGroups();
    fetchBranches();
  }, [fetchGroups, fetchBranches]);

  /* ================= FORM HANDLERS ================= */
  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleOpenAddModal = () => {
    setFormData({
      name: "",
      alias: "",
      group: "",
      openingBalance: "",
    });
    setEditIndex(null);
    setModalOpen(true);
  };

  const handleEdit = (item) => {
    setEditIndex(item.id);
    setFormData({
      name: item.name || "",
      alias: item.alias || "",
      group: item.group_id || "",
      openingBalance: item.openingBalance || "",
    });
    setModalOpen(true);
  };

  const createUpdate = async (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.alias ||
      !formData.group
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    const payload = {
      name: formData.name,
      alias: formData.alias,
      group_id: Number(formData.group),
      openingBalance: Number(formData.openingBalance || 0),
      superAdminId: Number(superAdminId),
      createdBy: Number(superAdminId),
      branchId: 1,
      status:"Active"
    };

    try {
      if (editIndex !== null) {
        // UPDATE
        const res = await axios.put(
          `${BASE_URL}/ledger/update/${editIndex}`,
          payload
        );
        toast.success(res?.data?.message || "Ledger updated successfully");
      } else {
        // CREATE
        const res = await axios.post(`${BASE_URL}/ledger/create`, payload);
        toast.success(res?.data?.message || "Ledger created successfully");
      }

      fetchLedgers();
      setModalOpen(false);
    } catch (error) {
      console.error("API Error:", error);
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to save ledger";
      toast.error(message);
    }
  };

  /* ================= DELETE HANDLERS ================= */
  const openDeleteModal = (id) => {
    setSelectedDeleteId(id);
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      const res = await axios.delete(
        `${BASE_URL}/ledger/delete/${selectedDeleteId}`
      );
      toast.success(res?.data?.message || "Ledger deleted successfully");
      fetchLedgers();
    } catch (error) {
      console.error("Delete Error:", error);
      toast.error(error?.response?.data?.message || "Failed to delete ledger");
    } finally {
      setDeleteModalOpen(false);
      setSelectedDeleteId(null);
    }
  };

  /* ================= SEARCH & FILTERING ================= */
  const filteredData = useMemo(() => {
    let data = [...ledgers];

    if (searchQuery.trim()) {
      data = data.filter((item) => {
        const nameMatch = item.name?.toLowerCase().includes(searchQuery.toLowerCase());
        const aliasMatch = item.alias?.toLowerCase().includes(searchQuery.toLowerCase());
        const groupMatch = String(item.group_id || "").includes(searchQuery);
        return nameMatch || aliasMatch || groupMatch;
      });
    }

    return data;
  }, [ledgers, searchQuery]);

  /* ================= PAGINATION COMPUTATIONS ================= */
  const isShowAll = rowsPerPage === "ALL";
  const totalEntries = filteredData.length;
  const effectiveRowsPerPage = isShowAll ? totalEntries : Number(rowsPerPage);

  const startIndex = isShowAll ? 0 : (currentPage - 1) * effectiveRowsPerPage;
  const endIndex = isShowAll
    ? totalEntries
    : Math.min(startIndex + effectiveRowsPerPage, totalEntries);

  const paginatedData =
    filteredData.length <= effectiveRowsPerPage || isShowAll
      ? filteredData
      : filteredData.slice(startIndex, endIndex);

  /* ================= EXPORT TO EXCEL ================= */
  const exportToExcel = () => {
    if (filteredData.length === 0) {
      toast.error("No data available to export");
      return;
    }

    const exportList = filteredData.map((item, index) => ({
      SN: index + 1,
      "Ledger Name": item.name || "N/A",
      Alias: item.alias || "N/A",
      "Group ID": item.group_id || "N/A",
      "Opening Balance": item.openingBalance || 0,
      Status: item.status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportList);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Ledgers");
    XLSX.writeFile(workbook, "Ledgers_Report.xlsx");
  };

  /* ================= EXPORT TO PDF ================= */
  const exportToPDF = async () => {
    if (!filteredData || filteredData.length === 0) {
      toast.error("No data available to export");
      return;
    }

    const doc = new jsPDF({
  orientation: "p",
  unit: "mm",
  format: "a4",
  compress: true,
});
    const pageWidth = doc.internal.pageSize.width;

    // ================= LOGO SECTION (SQUARE, NO BORDER) =================
    const logoX = 15;
    const logoY = 12;
    const logoSize = 22;

    if (company?.logoUrl) {
      const base64Logo = await getBase64ImageFromUrl(company.logoUrl);
      if (base64Logo) {
        try {
          const isJpeg =
            company.logoUrl.toLowerCase().includes(".jpg") ||
            company.logoUrl.toLowerCase().includes(".jpeg");
          const format = isJpeg ? "JPEG" : "PNG";

          doc.addImage(base64Logo, format, logoX, logoY, logoSize, logoSize);
        } catch (err) {
          console.warn("Logo draw error:", err);
        }
      }
    }

    // ================= COMPANY DETAILS =================
    const nameX = logoX + logoSize + 8;
    const nameY = 16;
    const nameMaxWidth = pageWidth - nameX - 15;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.setTextColor(2, 44, 58);

    const companyNameText = doc.splitTextToSize(
      (company?.name || "COMPANY NAME").toUpperCase(),
      nameMaxWidth
    );
    doc.text(companyNameText, nameX, nameY);

    let currentY = nameY + companyNameText.length * 5;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);

    const addressText = doc.splitTextToSize(
      company?.address || "Company Address",
      nameMaxWidth
    );
    doc.text(addressText, nameX, currentY);
    currentY += addressText.length * 4;

    doc.text(`Email: ${company?.email || "-"}`, nameX, currentY);
    currentY += 4;

    doc.text(`Phone: ${company?.contact || "-"}`, nameX, currentY);
    currentY += 10; // Extra gap before line

    // Divider Line
    doc.setDrawColor(220, 220, 220);
    doc.setLineWidth(0.3);
    doc.line(10, currentY, pageWidth - 10, currentY);

    // ================= REPORT TITLE =================
    currentY += 8;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text("Ledger List Report", pageWidth / 2, currentY, {
      align: "center",
    });

    // ================= TABLE DATA =================
    const tableColumn = [
      "SN",
      "Ledger Name",
      "Alias",
      "Group ID",
      "Opening Bal",
      "Status",
    ];
    const tableRows = filteredData.map((item, index) => [
      index + 1,
      item.name || "N/A",
      item.alias || "N/A",
      item.group_id || "N/A",
      `Rs. ${item.openingBalance || 0}`,
      item.status,
    ]);

    autoTable(doc, {
      startY: currentY + 6,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 3,
        halign: "center",
        valign: "middle",
        textColor: [50, 50, 50],
      },
      headStyles: {
        fillColor: [2, 44, 58],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        fontSize: 8.5,
        halign: "center",
      },
      alternateRowStyles: {
        fillColor: [248, 250, 252],
      },
      margin: { left: 10, right: 10, top: 10, bottom: 15 },

      didDrawPage: function (data) {
        const pWidth = doc.internal.pageSize.width;
        const pHeight = doc.internal.pageSize.height;

        // Page Border
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.2);
        doc.rect(8, 8, pWidth - 16, pHeight - 16);

        // Footer Page Numbering
        doc.setFontSize(8);
        doc.setTextColor(120, 120, 120);
        doc.text(
          `Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`,
          pWidth / 2,
          pHeight - 11,
          { align: "center" }
        );
      },
    });

    doc.save("Ledgers_Report.pdf");
  };

  return (
    <div className="account-ledger-list-container">
      <h2 className="heading">Ledger List</h2>

      {/* Top Controls Bar */}
      <div className="account-ledger-list-top-section">
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <span>Show</span>
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(
                e.target.value === "ALL" ? "ALL" : Number(e.target.value)
              );
              setCurrentPage(1);
            }}
            className="bw-entries-select"
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value="ALL">All</option>
          </select>
          <span>entries</span>
        </div>

        <input
          type="text"
          placeholder="Search by Ledger / Alias / Group..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />

        <div style={{ display: "flex", gap: "10px" }}>
          <button
            type="button"
            className="add-btn"
            style={{ backgroundColor: "#217346" }}
            onClick={exportToExcel}
            title="Export to Excel"
          >
            <FileSpreadsheet size={18} style={{ marginRight: "4px" }} /> Excel
          </button>

          <button
            type="button"
            className="add-btn"
            style={{ backgroundColor: "#b30b00" }}
            onClick={exportToPDF}
            title="Export to PDF"
          >
            <FileText size={18} style={{ marginRight: "4px" }} /> PDF
          </button>

          <button className="add-btn" onClick={handleOpenAddModal}>
            Add New
          </button>
        </div>
      </div>

      {/* Report Table */}
      <div className="account-ledger-list-report-section">
        <table className="account-ledger-list-report-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Ledger Name</th>
              <th>Alias</th>
              <th>Group ID</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", padding: "16px" }}>
                  Loading Data...
                </td>
              </tr>
            ) : paginatedData.length > 0 ? (
              paginatedData.map((item, index) => (
                <tr key={item.id || index}>
                  <td>{startIndex + index + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.alias}</td>
                  <td>{item.group_id}</td>
                  <td>{item.status}</td>
                  <td className="ledger-list-action-buttons">
                    <button
                      className="edit-icon-gl"
                      onClick={() => handleEdit(item)}
                      title="Edit"
                    >
                      <Edit size={18} />
                    </button>
                    <button
                      className="delete-icon-gl"
                      onClick={() => openDeleteModal(item.id)}
                      title="Delete"
                    >
                      <Trash size={18} />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", padding: "16px" }}>
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Bar */}
      {totalEntries > 0 && (
        <div className="account-ledger-list-pagination-section">
          <span>
            Showing {startIndex + 1} to {endIndex} of {totalEntries} entries
          </span>

          {!isShowAll && totalPages > 1 && (
            <div className="account-ledger-list-pagination-div">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                ⬅ Prev
              </button>

              <span>
                Page {currentPage} of {totalPages}
              </span>

              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next ➡
              </button>
            </div>
          )}
        </div>
      )}

      {/* Add/Edit Modal */}
      {modalOpen && (
        <div className="dialog-overlay">
          <div className="dialog-box">
            <h2 className="dialog-box-heading">
              {editIndex !== null ? "Edit Ledger" : "Add New Ledger"}
            </h2>

            <form className="dialog-box-form-section" onSubmit={createUpdate}>
            
              {/* <div className="dialog-box-input-group">
                <label>Select Branch</label>
                <select
                  name="branch"
                  value={formData.branch}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Branch</option>
                  {branches.map((br) => (
                    <option key={br.id || br._id} value={br.id || br._id}>
                      {br.name || br.branchName || `Branch ID: ${br.id}`}
                    </option>
                  ))}
                </select>
              </div> */}

               <div className="dialog-box-input-group">
                <label>Group</label>
                <select
                  name="group"
                  value={formData.group}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Group</option>
                  {groups.map((gn) => (
                    <option key={gn.id} value={gn.id}>
                      {gn.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="dialog-box-input-group">
                <label>Ledger Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter Ledger Name"
                  required
                />
              </div>

              <div className="dialog-box-input-group">
                <label>Alias</label>
                <input
                  type="text"
                  name="alias"
                  value={formData.alias}
                  onChange={handleChange}
                  placeholder="Enter Alias"
                  required
                />
              </div>

              <div className="dialog-box-input-group">
                <label>Opening Balance</label>
                <input
                  type="number"
                  name="openingBalance"
                  value={formData.openingBalance}
                  onChange={handleChange}
                  placeholder="Enter Opening Balance"
                />
              </div>


              <div className="dialog-btns">
                <button type="submit">
                  {editIndex !== null ? "Update" : "Create"}
                </button>

                <button type="button" onClick={() => setModalOpen(false)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {deleteModalOpen && (
        <div className="dialog-overlay">
          <div className="dialog-box" style={{ maxWidth: "400px" }}>
            <h2 className="dialog-box-heading">Confirm Delete</h2>
            <p style={{ margin: "15px 0", color: "#555" }}>
              Are you sure you want to delete this ledger? This action cannot be undone.
            </p>
            <div className="dialog-btns">
              <button
                type="button"
                onClick={confirmDelete}
                style={{ backgroundColor: "#d32f2f" }}
              >
                Delete
              </button>
              <button type="button" onClick={() => setDeleteModalOpen(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LedgerList;